import './App.css';
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AuthProvider, useAuth } from './context/AuthContext';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Leads from './pages/Leads';
import Pipeline from './pages/Pipeline';
import NewProposal from './pages/NewProposal';
import Proposals from './pages/Proposals';
import ProposalView from './pages/ProposalView';
import BOM from './pages/BOM';
import Team from './pages/Team';
import PublicProposal from './pages/PublicProposal';
import AppShell from './components/AppShell';

function Private({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell>{children}</AppShell>;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/share/:id" element={<PublicProposal />} />
          <Route path="/app" element={<Private><Dashboard /></Private>} />
          <Route path="/app/leads" element={<Private><Leads /></Private>} />
          <Route path="/app/pipeline" element={<Private><Pipeline /></Private>} />
          <Route path="/app/proposals" element={<Private><Proposals /></Private>} />
          <Route path="/app/proposals/new" element={<Private><NewProposal /></Private>} />
          <Route path="/app/proposals/:id" element={<Private><ProposalView /></Private>} />
          <Route path="/app/bom" element={<Private><BOM /></Private>} />
          <Route path="/app/team" element={<Private><Team /></Private>} />
        </Routes>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
